
import BasePerson from 'models/BasePerson'

export default class Person extends BasePerson {

  // アクセサ: 検索用キー値を取得
  static key(storeCode, floorCode, personCode) {
    if(storeCode instanceof Object) {
      floorCode  = storeCode.floor_code
      personCode = storeCode.person_code
      storeCode  = storeCode.store_code
    }
    return storeCode + '/' + floorCode + '/' + personCode
  }

  // アクセサ: 勤務時刻の表示用文字列
  getTimeLabel(week) {
    return this.constructor.makeTimeLabel(this['begin_time_' + week], this['end_time_' + week])
  }
}
